import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { StoreBackButton } from './StoreBackButton';
import './StoreStepContentHeader.scss';
/**
 * @component StoreStepContentHeader
 * @since 1.0.0
 */
export function StoreStepContentHeader(props) {
    const { backDisabled = false, backgroundImage = null, onBack, title = t('Start Your Experience'), variant = 'default' } = props;
    const className = classNames('store-step-content-header', props.className, {
        'store-step-content-header--compact': variant === 'compact',
        'store-step-content-header--on-image': variant === 'default' && !!backgroundImage,
        'store-step-content-header--with-back': !!onBack
    });
    return (React.createElement("div", { className: className },
        onBack && (React.createElement(StoreBackButton, { className: "store-step-content-header__back", disabled: backDisabled, onImage: variant === 'default' && !!backgroundImage, onPress: onBack })),
        React.createElement("h2", { className: "store-step-content-header__title" }, title)));
}
